export default "__VITE_ASSET__BuTvhwsX__"